import { ReactNode } from 'react';
import {
  BaseButton,
  BASE_BUTTON_VARIANT,
  BASE_BUTTON_COLOR,
} from '~/components/Global/Button';
import { BaseDialog } from './BaseDialog';

type TProps = {
  open: boolean;
  title: string;
  children: ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onClose: () => void;
};

/**
 * @description 共用的確認彈窗（確定 / 取消）。title 與內文由呼叫端傳入。
 */
export const ConfirmDialog = ({
  open,
  title,
  children,
  confirmText = '確定',
  cancelText = '取消',
  onConfirm,
  onClose,
}: TProps) => {
  return (
    <BaseDialog
      open={open}
      handleClose={onClose}
      title={title}
      action={
        <>
          <BaseButton
            variant={BASE_BUTTON_VARIANT.OUTLINED}
            color={BASE_BUTTON_COLOR.PRIMARY}
            text={cancelText}
            onClick={onClose}
          />
          <BaseButton
            variant={BASE_BUTTON_VARIANT.FILLED}
            color={BASE_BUTTON_COLOR.PRIMARY}
            text={confirmText}
            onClick={onConfirm}
          />
        </>
      }
    >
      {children}
    </BaseDialog>
  );
};
